import { observer } from 'mobx-react'
import { node } from 'prop-types'

import './index.scss'

const WidthWrapper = observer(({ className = '', children }) => {
  return <div className={`width-wrapper-component ${className || ''}`}>{children}</div>
})

WidthWrapper.propTypes = {
  children: node,
}

WidthWrapper.displayName = 'WidthWrapper'

export default WidthWrapper
